module.exports = __webpack_public_path__ + "files/d3a58dfe7ce7dbd2cc4ac083014ca3d3.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Ubuntu-regular.eot
 ** module id = 400
 ** module chunks = 0
 **/